import {ShieldUser} from "lucide-react";

import {cn} from "@/lib/utils";

import {
  DispatchDeskCardShell,
  DispatchDeskContactRow,
  DispatchDeskEmptyMessage,
  DispatchDeskEmptyPanelBody,
  DispatchDeskNestedList,
  DispatchDeskScrollRegion,
} from "./dispatch-desk-card";
import {useDispatchDeskProperty} from "../hooks/use-dispatch-desk-property";
import {
  DISPATCH_DESK_NO_PROPERTY_MESSAGE,
  DISPATCH_DESK_PANEL_CLASS,
} from "../lib/dispatch-desk-layout";

type DispatchPropertyManagersProps = {
  className?: string;
};

export function DispatchPropertyManagers({className}: DispatchPropertyManagersProps) {
  const property = useDispatchDeskProperty();
  const managers = property?.property_managers ?? [];

  return (
    <DispatchDeskCardShell
      className={cn(DISPATCH_DESK_PANEL_CLASS, className)}
      icon={ShieldUser}
      iconClassName="text-primary"
      title="Managers"
    >
      <DispatchDeskScrollRegion>
        {!property ? (
          <DispatchDeskEmptyPanelBody>
            <DispatchDeskEmptyMessage>{DISPATCH_DESK_NO_PROPERTY_MESSAGE}</DispatchDeskEmptyMessage>
          </DispatchDeskEmptyPanelBody>
        ) : managers.length === 0 ? (
          <DispatchDeskEmptyPanelBody>
            <DispatchDeskEmptyMessage>No managers on file.</DispatchDeskEmptyMessage>
          </DispatchDeskEmptyPanelBody>
        ) : (
          <DispatchDeskNestedList>
            {managers.map((manager) => {
              const name = `${manager.first_name} ${manager.last_name}`.trim();
              return (
                <DispatchDeskContactRow
                  key={manager.id}
                  name={name}
                  phone={manager.telephone}
                  callLabel={name}
                />
              );
            })}
          </DispatchDeskNestedList>
        )}
      </DispatchDeskScrollRegion>
    </DispatchDeskCardShell>
  );
}
